import React from "react";
import { DocumentDuplicateIcon } from "@heroicons/react/24/solid";
import { useAuth } from "../../context/AuthContext";
import ThemeToggle from "../ThemeToggle";

interface BreadcrumbProps {
  title: string;
}

export default function Breadcrumb({ title }: BreadcrumbProps) {
  const { logout } = useAuth();

  return (
    <div className="bg-white dark:bg-gray-950 border-b border-gray-200 dark:border-gray-800 px-6 py-3.5 flex items-center justify-between transition-colors duration-200">
      <div className="flex items-center">
        <DocumentDuplicateIcon className="h-5 w-5 text-gray-500 dark:text-gray-400 mr-2" />
        <h1 className="text-xl font-medium text-gray-900 dark:text-white">
          {title}
        </h1>
      </div>

      <div className="flex items-center space-x-3">
        <ThemeToggle />
        <button
          onClick={logout}
          className="px-3 py-1.5 rounded-md bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-sm hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
